import CardView from './CardView'
import CalenderView from './CalenderView'
import { Row, Col } from 'antd'
import TableView from './TableView'
import { creationEventStore } from 'state/event/eventCreationStore'
import DuplicateModal from 'pages/Events/Views/Modal/DuplicateModal'
const EventView = ({ data, parms, setParms, view }: any) => {
  const { duplicateModalOpen } = creationEventStore(store => ({
    duplicateModalOpen: store.duplicateModalOpen,
  }))
  return (
    <div>
      <Row gutter={[10, 24]} align="middle">
        <Col>
          <div className="mt-20px">
            {view === 'cardview' && (
              <CardView events={data} parms={parms} setParms={setParms} />
            )}
            {view === 'calendar' && <CalenderView events={data} />}
            {view === 'tableview' && (
              <TableView events={data} setParms={setParms} />
            )}
          </div>
        </Col>
      </Row>
      {duplicateModalOpen && <DuplicateModal />}
    </div>
  )
}

export default EventView
